import { useMutation, useQueryClient } from '@tanstack/react-query';

import { message } from 'antd';

import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import Api from '@app/services/api';

export const useDeleteInvitationQuery = () => {
  const client = useQueryClient();
  const commonT = useTranslation(NSKeys.common);

  return useMutation({
    mutationFn: async (invitation_uuid: string) => {
      await Api.users.getDeleteInvitations(invitation_uuid);
    },
    onSuccess: async () => {
      message.open({
        type: 'success',
        content: commonT.t('dataPatchSuccess'),
      });
      await client.invalidateQueries(['getEmployeeInvites']);
    },
    onError: async () => {
      message.open({
        type: 'error',
        content: commonT.t('error400'),
      });
      await client.invalidateQueries(['getProjects']);
    },
  });
};
